import React, { SelectHTMLAttributes } from "react";

interface Item {
  id: string;
  descricao: string
}

interface SelectSituacaoProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  nameSelect: string;
  items: Item[]
  infoTel?: string
}

export const SelectTelefone = ({ name, nameSelect, items, infoTel, ...rest }: SelectSituacaoProps) => {
  const manual = !infoTel && nameSelect === 'Origem' ? items.find(item => item.descricao === 'Manual') : {} as Item

  function renderSelect() {
    if (nameSelect === 'Origem') {
      if (!infoTel && manual && manual?.id) {
        return <option key={manual.id} value={manual.descricao}>{manual.descricao}</option>
      } else {
        return <>
          <option key={'Todos'} value={''}>{''}</option>
          {
            items && items?.length > 0 && items.map(item => (
              <option key={item.id} value={item.descricao}>{item.descricao}</option>
            ))
          }
        </>
      }
    } else {
      return (
        <>
          <option key={'Todos'} value={''}>{''}</option>
          {
            items && items?.length > 0 && items.map(item => (
              <option key={item.id} value={item.descricao}>{item.descricao}</option>
            ))
          }
        </>
      )
    }
  }
  return (
    <div className="my-2 flex h-8 w-full items-center justify-between gap-4">
      <p className="w-2/6 font-medium text-gray-700">{nameSelect}: </p>
      <select className="h-full w-full bg-gray-200 px-1 py-2" name={name} {...rest} >
        <optgroup className=" text-sm">

          {renderSelect()}
        </optgroup>

      </select>
    </div>
  )
}